var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.174 3.657a.547.547 0 0 1 .382-.157h10.888c.141 0 .278.055.382.157L8 7.58 2.174 3.657ZM0 4.05V11.929c0 .678.267 1.331.745 1.814.478.484 1.13.757 1.81.757h10.89c.68 0 1.332-.273 1.81-.757A2.58 2.58 0 0 0 16 11.93V4.054a2.579 2.579 0 0 0-.745-1.797 2.548 2.548 0 0 0-1.81-.757H2.554c-.68 0-1.332.273-1.81.757A2.58 2.58 0 0 0 0 4.05Zm14 1.9v5.978a.58.58 0 0 1-.166.407.548.548 0 0 1-.39.164H2.556a.548.548 0 0 1-.39-.164A.58.58 0 0 1 2 11.93V5.95l5.441 3.665a1 1 0 0 0 1.118 0L14 5.95Z",
    clipRule: "evenodd"
  })));
};
export default SvgMail;